const topics = [
  { label: '热播剧追更', desc: '每日更新进度表', icon: 'ri-fire-line', color: 'primary' },
  { label: '新片速递', desc: '院线下线即上线', icon: 'ri-rocket-line', color: 'accent' },
  { label: '综艺大赏', desc: '热门综艺一网打尽', icon: 'ri-tv-2-line', color: 'primary' },
  { label: '高分经典', desc: '豆瓣8分以上佳作', icon: 'ri-star-line', color: 'accent' },
  { label: '悬疑烧脑', desc: '反转不断高能预警', icon: 'ri-ghost-line', color: 'primary' },
  { label: '动作大片', desc: '肾上腺素飙升', icon: 'ri-flashlight-line', color: 'accent' },
  { label: '甜宠剧场', desc: '高甜恋爱一次看够', icon: 'ri-heart-line', color: 'primary' },
  { label: '动漫番剧', desc: '国漫日漫同步更新', icon: 'ri-emotion-line', color: 'accent' },
  { label: '纪录纪实', desc: '真实故事深度观察', icon: 'ri-camera-line', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            精选热门影视专题，快速找到你想看的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-center gap-4 p-5 bg-background-100 hover:bg-background-200 rounded-xl cursor-pointer transition-colors"
            >
              <span
                className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center ${
                  topic.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
                }`}
              >
                <i
                  className={`${topic.icon} text-lg ${
                    topic.color === 'primary' ? 'text-primary-500' : 'text-accent-500'
                  }`}
                ></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {topic.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{topic.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 ml-auto flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}